module.exports = __webpack_public_path__ + "static/1-d06e90f347392692f0aabb3f3e24ef04.jpg";